import { useState } from 'react';

import '../../styles/announcement.css';
import '../../styles/global.css';

const AnnouncementCard = ({ announcement, index }) => {
  const [expanded, setExpanded] = useState(false);
  const text = announcement.announcement;
  const maxLength = 160; // chars to show before truncating

  const toggleExpand = () => setExpanded(!expanded);
  const hasImages = announcement.images?.length > 0;

  const defaultImage =
    index % 2 === 0
      ? '/default-announcement1.png'
      : '/default-announcement2.png';

  return (
    <div className="announcement-card">
      {hasImages ? (
        announcement.images.map((photo, idx) => (
          <img
            key={photo._id || idx}
            src={photo.key}
            alt={photo.altText || 'Announcement Photo'}
            className="announcement-card-image"
          />
        ))
      ) : (
        <img
          className="announcement-card-image"
          src={defaultImage}
          alt="announcement"
        />
      )}

      <div className="announcement-card-content">
        <h3 className="text-lg font-bold">{announcement.announcementTitle}</h3>
        <p>
          {expanded || text.length <= maxLength
            ? text
            : `${text.substring(0, maxLength)}...`}
          {text.length > maxLength && (
            <span className="see-more" onClick={toggleExpand}>
              {expanded ? ' See less' : ' See more'}
            </span>
          )}
        </p>
        <p className="announcement-card-date">
          {new Date(announcement.createdAt).toLocaleDateString()}
        </p>
      </div>
    </div>
  );
};

export default AnnouncementCard;
